import React from 'react';
import './about.css';
import ME from '../../assets/me-about2.jpg';
import {FaAward} from 'react-icons/fa';
import {FiUsers} from 'react-icons/fi';
import {VscFolderLibrary} from 'react-icons/vsc';

const about = () => {
  return (
    <section id='about'>
      <h5>Get to Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className='about__me'>
          <div className="about__me-image">
            <img src={ME} alt="About Image" />
          </div>
        </div>
      

      <div className="about__content">
        <div className="about__cards">
          <article className='about__card'>
            <FaAward className='about__icon'/>
            <h5>Experience</h5>
            <small>Fresher</small>
          </article>

          <article className='about__card'>
            <FiUsers className='about__icon'/>
            <h5>Clients</h5>
            <small>Searching</small>
          </article>

          <article className='about__card'>
            <VscFolderLibrary className='about__icon'/>
            <h5>Projects</h5>
            <small>2+ Completed</small>
          </article>
        </div>

        <p>Hello! I'm Abhi Patel, a recent Computer Engineering graduate and enthusiastic Full Stack Developer skilled in HTML, CSS, JavaScript, React.js, Node.js, and MongoDB. Excited to contribute innovation and collaborate on dynamic web projects. Let's build something great together!</p>

        <a href="#contact" className='btn btn-primary'>Let's Talk</a>

      </div>
      </div>
    </section>
  )
}

export default about
